<p>{{'recallCenter_introDescText' | translate}}</p>
<p *ngIf="showBoltLink">{{'recallCenter_boltIntroText' | translate}}
  <span class="gb-body1 heavy">{{'recallCenter_chevyEVBold' | translate}}</span>
  {{'recallCenter_boltRecallMiscText' | translate}}
  <a [href]="'https://'.concat('recallCenter_chevyRecallLink' | translate)" target="_blank">{{'recallCenter_chevyRecallLink' | translate}}</a>
  <span>.</span>
</p>
<p *ngIf="isTakataEligible" class="mb-10">{{'recallCenter_takataRecallText' | translate}}
  <span class="gb-body1 heavy">{{'recallCenter_takataBoldText' | translate}}</span>
  {{'recallCenter_takataMiscText' | translate}}
  <a [href]="'https://'.concat('recallCenter_takataRecallLink' | translate)" target="_blank">{{'recallCenter_takataLinkText' | translate}}</a>
  {{'recallCenter_takataPhoneText' | translate}}
</p>
